/**
 * Exported Shopify Polaris inspired foundation colors.
 * @see https://polaris.shopify.com/design/colors
 */

export const gray = {
  1: 'rgba(255, 255, 255, 1)',
  2: 'rgba(253, 253, 253, 1)',
  3: 'rgba(250, 250, 250, 1)',
  4: 'rgba(247, 247, 247, 1)',
  5: 'rgba(243, 243, 243, 1)',
  6: 'rgba(241, 241, 241, 1)',
  7: 'rgba(235, 235, 235, 1)',
  8: 'rgba(227, 227, 227, 1)',
  9: 'rgba(212, 212, 212, 1)',
  10: 'rgba(204, 204, 204, 1)',
  11: 'rgba(181, 181, 181, 1)',
  12: 'rgba(138, 138, 138, 1)',
  13: 'rgba(97, 97, 97, 1)',
  14: 'rgba(74, 74, 74, 1)',
  15: 'rgba(48, 48, 48, 1)',
  16: 'rgba(26, 26, 26, 1)',
};

export const azure = {
  1: 'rgba(251, 253, 255, 1)',
  2: 'rgba(242, 249, 255, 1)',
  3: 'rgba(234, 244, 255, 1)',
  4: 'rgba(224, 240, 255, 1)',
  5: 'rgba(213, 235, 255, 1)',
  6: 'rgba(202, 230, 255, 1)',
  7: 'rgba(192, 225, 255, 1)',
  8: 'rgba(168, 216, 255, 1)',
  9: 'rgba(145, 208, 255, 1)',
  10: 'rgba(81, 192, 255, 1)',
  11: 'rgba(0, 148, 213, 1)',
  12: 'rgba(0, 124, 180, 1)',
  13: 'rgba(0, 103, 155, 1)',
  14: 'rgba(0, 82, 124, 1)',
  15: 'rgba(0, 58, 90, 1)',
  16: 'rgba(0, 33, 51, 1)',
};

export const blue = {
  1: '#F3F9FF',
  2: '#E8F5FF',
  3: '#DDF1FF',
  4: '#D1ECFF',
  5: '#C6E7FF',
  6: '#BBE3FF',
  7: '#AFDEFF',
  8: '#A4DAFF',
  9: '#99D5FF',
  10: '#62BEFF',
  11: '#1F93FF',
  12: '#1673CC',
  13: '#0E5399',
  14: '#073466',
  15: '#031633',
  16: '#0A1D2E',
};

export const green = {
  1: 'rgba(250, 255, 251, 1)',
  2: 'rgba(230, 254, 234, 1)',
  3: 'rgba(205, 254, 212, 1)',
  4: 'rgba(175, 254, 191, 1)',
  5: 'rgba(146, 252, 172, 1)',
  6: 'rgba(110, 247, 153, 1)',
  7: 'rgba(82, 244, 144, 1)',
  8: 'rgba(44, 237, 131, 1)',
  9: 'rgba(17, 223, 123, 1)',
  10: 'rgba(24, 191, 121, 1)',
  11: 'rgba(13, 156, 106, 1)',
  12: 'rgba(4, 123, 93, 1)',
  13: 'rgba(3, 94, 76, 1)',
  14: 'rgba(1, 75, 64, 1)',
  15: 'rgba(7, 54, 48, 1)',
  16: 'rgba(2, 38, 34, 1)',
};

export const lime = {
  1: 'rgba(250, 255, 250, 1)',
  2: 'rgba(228, 255, 229, 1)',
  3: 'rgba(208, 255, 209, 1)',
  4: 'rgba(187, 254, 190, 1)',
  5: 'rgba(157, 254, 160, 1)',
  6: 'rgba(119, 254, 122, 1)',
  7: 'rgba(56, 254, 62, 1)',
  8: 'rgba(40, 242, 47, 1)',
  9: 'rgba(37, 232, 43, 1)',
  10: 'rgba(32, 207, 39, 1)',
  11: 'rgba(24, 168, 29, 1)',
  12: 'rgba(17, 135, 21, 1)',
  13: 'rgba(12, 113, 15, 1)',
  14: 'rgba(11, 85, 13, 1)',
  15: 'rgba(3, 61, 5, 1)',
  16: 'rgba(3, 33, 4, 1)',
};

export const magenta = {
  1: 'rgba(255, 253, 255, 1)',
  2: 'rgba(255, 245, 255, 1)',
  3: 'rgba(253, 239, 253, 1)',
  4: 'rgba(254, 231, 254, 1)',
  5: 'rgba(252, 223, 252, 1)',
  6: 'rgba(251, 215, 251, 1)',
  7: 'rgba(251, 207, 251, 1)',
  8: 'rgba(249, 190, 249, 1)',
  9: 'rgba(248, 177, 248, 1)',
  10: 'rgba(246, 141, 246, 1)',
  11: 'rgba(225, 86, 225, 1)',
  12: 'rgba(197, 48, 197, 1)',
  13: 'rgba(159, 38, 159, 1)',
  14: 'rgba(121, 26, 121, 1)',
  15: 'rgba(86, 16, 86, 1)',
  16: 'rgba(52, 6, 52, 1)',
};

export const orange = {
  1: 'rgba(255, 253, 250, 1)',
  2: 'rgba(255, 247, 238, 1)',
  3: 'rgba(255, 241, 227, 1)',
  4: 'rgba(255, 235, 213, 1)',
  5: 'rgba(255, 228, 198, 1)',
  6: 'rgba(255, 221, 182, 1)',
  7: 'rgba(255, 214, 164, 1)',
  8: 'rgba(255, 200, 121, 1)',
  9: 'rgba(255, 184, 0, 1)',
  10: 'rgba(229, 165, 0, 1)',
  11: 'rgba(178, 132, 0, 1)',
  12: 'rgba(149, 111, 0, 1)',
  13: 'rgba(124, 88, 0, 1)',
  14: 'rgba(94, 66, 0, 1)',
  15: 'rgba(65, 45, 0, 1)',
  16: 'rgba(37, 26, 0, 1)',
};

export const purple = {
  1: 'rgba(253, 253, 255, 1)',
  2: 'rgba(248, 247, 255, 1)',
  3: 'rgba(243, 241, 255, 1)',
  4: 'rgba(239, 236, 255, 1)',
  5: 'rgba(233, 229, 255, 1)',
  6: 'rgba(228, 222, 255, 1)',
  7: 'rgba(223, 217, 255, 1)',
  8: 'rgba(212, 204, 255, 1)',
  9: 'rgba(199, 188, 255, 1)',
  10: 'rgba(170, 149, 255, 1)',
  11: 'rgba(148, 116, 255, 1)',
  12: 'rgba(128, 81, 255, 1)',
  13: 'rgba(113, 38, 255, 1)',
  14: 'rgba(87, 0, 209, 1)',
  15: 'rgba(59, 0, 147, 1)',
  16: 'rgba(28, 0, 79, 1)',
};

export const red = {
  1: 'rgba(255, 250, 251, 1)',
  2: 'rgba(255, 246, 248, 1)',
  3: 'rgba(255, 236, 239, 1)',
  4: 'rgba(254, 232, 235, 1)',
  5: 'rgba(254, 225, 230, 1)',
  6: 'rgba(254, 217, 223, 1)',
  7: 'rgba(254, 209, 215, 1)',
  8: 'rgba(254, 193, 199, 1)',
  9: 'rgba(253, 172, 177, 1)',
  10: 'rgba(247, 128, 134, 1)',
  11: 'rgba(226, 44, 56, 1)',
  12: 'rgba(199, 10, 36, 1)',
  13: 'rgba(163, 10, 36, 1)',
  14: 'rgba(142, 11, 33, 1)',
  15: 'rgba(95, 7, 22, 1)',
  16: 'rgba(47, 4, 11, 1)',
};

export const yellow = {
  1: 'rgba(255, 253, 246, 1)',
  2: 'rgba(255, 248, 219, 1)',
  3: 'rgba(255, 244, 191, 1)',
  4: 'rgba(255, 239, 157, 1)',
  5: 'rgba(255, 235, 120, 1)',
  6: 'rgba(255, 230, 0, 1)',
  7: 'rgba(247, 223, 0, 1)',
  8: 'rgba(234, 211, 0, 1)',
  9: 'rgba(225, 203, 0, 1)',
  10: 'rgba(197, 178, 0, 1)',
  11: 'rgba(153, 138, 0, 1)',
  12: 'rgba(130, 117, 0, 1)',
  13: 'rgba(105, 95, 0, 1)',
  14: 'rgba(79, 71, 0, 1)',
  15: 'rgba(51, 46, 0, 1)',
  16: 'rgba(31, 28, 0, 1)',
};

export const teal = {
  1: 'rgba(248, 255, 254, 1)',
  2: 'rgba(232, 252, 250, 1)',
  3: 'rgba(215, 250, 247, 1)',
  4: 'rgba(195, 247, 242, 1)',
  5: 'rgba(170, 246, 239, 1)',
  6: 'rgba(137, 245, 236, 1)',
  7: 'rgba(112, 240, 229, 1)',
  8: 'rgba(90, 230, 219, 1)',
  9: 'rgba(44, 224, 212, 1)',
  10: 'rgba(30, 199, 188, 1)',
  11: 'rgba(0, 161, 152, 1)',
  12: 'rgba(18, 131, 124, 1)',
  13: 'rgba(12, 106, 100, 1)',
  14: 'rgba(12, 83, 79, 1)',
  15: 'rgba(3, 60, 57, 1)',
  16: 'rgba(6, 44, 41, 1)',
};

export const blackAlpha = {
  1: 'rgba(0, 0, 0, 0)',
  2: 'rgba(0, 0, 0, 0.01)',
  3: 'rgba(0, 0, 0, 0.02)',
  4: 'rgba(0, 0, 0, 0.03)',
  5: 'rgba(0, 0, 0, 0.05)',
  6: 'rgba(0, 0, 0, 0.06)',
  7: 'rgba(0, 0, 0, 0.08)',
  8: 'rgba(0, 0, 0, 0.11)',
  9: 'rgba(0, 0, 0, 0.17)',
  10: 'rgba(0, 0, 0, 0.20)',
  11: 'rgba(0, 0, 0, 0.29)',
  12: 'rgba(0, 0, 0, 0.46)',
  13: 'rgba(0, 0, 0, 0.62)',
  14: 'rgba(0, 0, 0, 0.71)',
  15: 'rgba(0, 0, 0, 0.81)',
  16: 'rgba(0, 0, 0, 0.90)',
};

export const whiteAlpha = {
  1: 'rgba(255, 255, 255, 0.01)',
  2: 'rgba(255, 255, 255, 0.02)',
  3: 'rgba(255, 255, 255, 0.03)',
  4: 'rgba(255, 255, 255, 0.04)',
  5: 'rgba(255, 255, 255, 0.05)',
  6: 'rgba(255, 255, 255, 0.06)',
  7: 'rgba(255, 255, 255, 0.08)',
  8: 'rgba(255, 255, 255, 0.11)',
  9: 'rgba(255, 255, 255, 0.14)',
  10: 'rgba(255, 255, 255, 0.17)',
  11: 'rgba(255, 255, 255, 0.22)',
  12: 'rgba(255, 255, 255, 0.29)',
  13: 'rgba(255, 255, 255, 0.44)',
  14: 'rgba(255, 255, 255, 0.6)',
  15: 'rgba(255, 255, 255, 0.7)',
  16: 'rgba(255, 255, 255, 0.8)',
};

export const foundationColors = {
  'brand-azure': azure,
  'brand-blue': blue,
  'brand-gray': gray,
  'brand-green': green,
  'brand-orange': orange,
  'brand-red': red,
  'brand-yellow': yellow,
  'brand-white-alpha': whiteAlpha,
  'brand-black-alpha': blackAlpha,
  'brand-purple': purple,
};
